import React, { useContext, useState } from "react";
import { BsArrowUpSquareFill } from "react-icons/bs";
import { InitializeContext } from "../App";

export default function ScrollToTop() {
  const { theme } = useContext(InitializeContext);
  const [visible, setVisible] = useState<boolean>(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <div className={`fixed cursor-pointer ${theme ? 'text-[#ECF0F3]' : ''} text-[2.5rem] w-100 z-10 left-[84%] md:left-[93%] lg:left-[96%] bottom-[115px] md:bottom-[60px] lg:bottom-[70px] h-[20px]`}>
      <BsArrowUpSquareFill
        size={30}
        onClick={scrollToTop}
        style={{ display: visible ? "inline" : "none" }}
      />
    </div>
  );
};
